var ScrollRestorationManager_1;
import { __decorate, __metadata, __param } from "tslib";
import qs from 'qs';
import _ from 'lodash';
import { rvTrack } from 'track';
import { DebugLogServiceSymbol } from './DebugLogService';
import { provide } from 'inversify-binding-decorators';
import { inject } from '@/inversify.config';
const SCROLL_RESTORATION_MANAGER_STORE_KEY = 'SCROLL_RESTORATION_MANAGER:RECORD';
export const ScrollRestorationManagerSymbol = Symbol.for('ScrollRestorationManager');
let ScrollRestorationManager = class ScrollRestorationManager {
    static { ScrollRestorationManager_1 = this; }
    constructor(debugLogService) {
        this.debugLogService = debugLogService;
        this.diffWatchArgs = ['spaceId', 'folderId', 'page', 'cond', 'sort', 'qid', 'efqid', 'aiFieldId'];
        this.recording = false;
        this.record = _.debounce((restorationInfo) => {
            if (!this.recording)
                return;
            try {
                localStorage.setItem(SCROLL_RESTORATION_MANAGER_STORE_KEY, JSON.stringify(restorationInfo));
                return restorationInfo;
            }
            catch (error) {
                console.warn('[RESTORE] record', error);
            }
        }, 50);
        this.getFirstVisibleElementWithDebounce = _.debounce(this.getFirstVisibleElement, 20);
        if (typeof ScrollRestorationManager_1.instance === 'object') {
            return ScrollRestorationManager_1.instance;
        }
        this.init();
        ScrollRestorationManager_1.instance = this;
        return this;
    }
    isSameUrl(url1, url2, watch) {
        // watch空时候全比对
        if (!watch || !watch?.length) {
            return url1 === url2;
        }
        // url空不比对
        if (!url1 || !url2) {
            return false;
        }
        const URL1 = new URL(url1);
        const URL2 = new URL(url2);
        // 比对视图
        if (URL1.pathname !== URL2.pathname) {
            return false;
        }
        // 比对watch参数
        const query1 = qs.parse(URL1.search.replace('?', ''));
        const query2 = qs.parse(URL2.search.replace('?', ''));
        for (const key of watch) {
            if (query1[key] !== query2[key]) {
                return false;
            }
        }
        return true;
    }
    startRecording(delay = 3000) {
        setTimeout(() => {
            this.recording = true;
        }, delay);
    }
    stopRecording() {
        this.recording = false;
    }
    get isRecording() {
        return this.recording;
    }
    getRecord() {
        let restorationInfo = {
            url: '',
            record: '',
        };
        try {
            const log = localStorage.getItem(SCROLL_RESTORATION_MANAGER_STORE_KEY);
            if (log) {
                restorationInfo = JSON.parse(log);
            }
        }
        catch (e) {
            console.warn('[RESTORE] getRecord', e);
        }
        return restorationInfo;
    }
    getFirstVisibleElement(elements, part = false) {
        const result = {
            el: null,
            area: 0,
        };
        for (let i = 0; i < elements.length; i++) {
            const rect = elements[i].getBoundingClientRect();
            if (part) {
                const vh = Math.min((window.innerHeight || document.documentElement.clientHeight), rect.bottom) - Math.max(0, rect.top);
                const vw = Math.min((window.innerWidth || document.documentElement.clientWidth), rect.right) - Math.max(0, rect.left);
                const area = vh * vw;
                if (result.area < area) {
                    result.el = elements[i];
                    result.area = area;
                }
            }
            else {
                if (rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)) {
                    // 元素在可视范围内
                    return elements[i];
                }
            }
        }
        // 所有 div 都不在可视范围内
        return result.el;
    }
    /**
     * 清除缓存
     */
    reset() {
        try {
            localStorage.removeItem(SCROLL_RESTORATION_MANAGER_STORE_KEY);
        }
        catch (error) {
            console.warn('[RESTORE] reset', error);
        }
    }
    init() {
        const restorationInfo = this.getRecord();
        if (!this.isSameUrl(restorationInfo.url, window.location.href, this.diffWatchArgs)) {
            this.reset();
        }
        return this;
    }
    setScrollAction(action, fallback) {
        this.scrollAction = action;
        this.scrollFallbackAction = fallback || _.noop;
    }
    setDiffWatchArgs(args) {
        this.diffWatchArgs = args;
    }
    restore() {
        // 判断页面
        const isDetailPage = /^\/detail/i.test(window.location.pathname);
        if (!isDetailPage) {
            return;
        }
        // 判断符合条件
        const restorationInfo = this.getRecord();
        if (this.isSameUrl(restorationInfo.url, window.location.href, this.diffWatchArgs) && _.isFunction(this.scrollAction)) {
            this.scrollAction(restorationInfo, this);
            rvTrack('Scroll Restoration Restore');
        }
        else {
            if (_.isFunction(this.scrollFallbackAction)) {
                this.scrollFallbackAction(restorationInfo, this);
            }
        }
    }
};
ScrollRestorationManager = ScrollRestorationManager_1 = __decorate([
    provide(ScrollRestorationManagerSymbol),
    __param(0, inject(DebugLogServiceSymbol)),
    __metadata("design:paramtypes", [Object])
], ScrollRestorationManager);
export { ScrollRestorationManager };
